import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Title from './Title'
import Controls from './Controls'
import Poster from './Poster'
import Credit from './Credit'
import Answer from './Answer'
import theme from './ui/theme'
import './App.css';

class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      posters: [],
      actual_poster_id: 0,
      displayAnswer: false
    };
  }

  componentDidMount() {
    this.getPosters();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.actual_poster_id !== this.state.actual_poster_id) {
      this.props.history.push("/" + this.state.actual_poster_id);
    }
  }

  getPosters() {
    return fetch('./posters.json')
    .then((response) => response.json())
    .then((responseJson) => {
      this.configureApp(responseJson);
    })
    .catch((error) => {
      console.error(error);
    });
  }

  configureApp(configurationJson) {
    const base_url = configurationJson.base_url;
    const posters = configurationJson.posters;

    posters.forEach((poster) => {
        poster.poster = base_url + poster.poster;
        poster.poster_solution = base_url + poster.poster_solution;
      }
    );

    this.setPosters(posters);
  }
  
  setPosters(posters) {

    const url = this.props.location.pathname;
    const data = (url.match(/(\d+)/g) || []);
    let init_id_poster = posters.length - 1;
    
    if (data.length > 0) {
      init_id_poster = Math.min(posters.length - 1, data[0]);
    }

    this.setState(
      {
        posters,
        actual_poster_id: init_id_poster
      }
    )
  }

  handleClickOnAnswer = () => {
    this.setState(
      {
        displayAnswer: true
      }
    );
  }

  handleClickOnContinue = () => {
    this.handleClickOnNext();
  }

  handleClickOnPrevious = () => {
    const actual_poster_id = this.state.actual_poster_id;
    const posters = this.state.posters;
    const new_poster_id = (actual_poster_id + 1) % posters.length;

    this.setState(
      {
        actual_poster_id: new_poster_id,
        displayAnswer: false
      }
    );
  }

  handleClickOnNext = () => {
    const actual_poster_id = this.state.actual_poster_id;
    const posters = this.state.posters;
    let new_poster_id = (actual_poster_id - 1) % posters.length;
    if (new_poster_id < 0 ) {
      new_poster_id = posters.length - 1;
    }

    this.setState(
      {
        actual_poster_id: new_poster_id,
        displayAnswer: false
      }
    );
  }

  handleClickOnRandom = () => {
    const posters = this.state.posters;
    const random_id = Math.floor(Math.random() * Math.floor(posters.length));
    this.setState(
      {
        actual_poster_id: random_id,
        displayAnswer: false
      }
    );
  }

  isPostersReady() {
    return (this.state.posters.length !== 0);
  }

  render() {
    if (!this.isPostersReady()) {
      return (
        <ThemeProvider theme={theme}>
          <div className="loading">
            <CircularProgress />
          </div>
        </ThemeProvider>
      );
    }

    const movie = this.state.posters[this.state.actual_poster_id];
    const displayAnswer = this.state.displayAnswer;
    return (
      <ThemeProvider theme={theme}>
        <div className="App">
            <div className="title">
              <Title />
              <Controls onPrevious={this.handleClickOnPrevious} 
                        onRandom={this.handleClickOnRandom} 
                        onNext={this.handleClickOnNext} />
            </div>
            <div className="poster">
              <Poster movie={movie} displayAnswer={displayAnswer} />
            </div>
            <div className="answer">
              <Answer movie={movie} 
                      displayAnswer={displayAnswer} 
                      onAnswer={this.handleClickOnAnswer} 
                      onContinue={this.handleClickOnContinue} />
            </div>
            <div className="credit">
              <Credit movie={movie} />
            </div>
        </div>
      </ThemeProvider>
    );
  }
}

export default App;
